import React from "react"
import PropTypes from "prop-types"
import { OverlayTrigger, PopOver } from "@tencent/spaui"
import _ from "lodash"

class AttachmentLinks extends React.Component {
  static propTypes = {
    attachments: PropTypes.arrayOf(PropTypes.object),
  }

  render() {
    const { attachments } = this.props
    if (!attachments) {
      return null
    }
    const elements = []
    for (let attachment of attachments) {
      if (attachment.contentType.startsWith("image/")) {
        elements.push(
          <OverlayTrigger
            key={attachment.id}
            placement="top"
            alignment="left"
            overlay={
              <PopOver delay="0">
                <img src={attachment.url} alt={attachment.name} style={{ width: "100%", height: "100%" }} />
              </PopOver>
            }
          >
            <a href={attachment.url}>【{attachment.name}】</a>
          </OverlayTrigger>
        )
      } else {
        elements.push(
          <a key={attachment.id} href={attachment.url}>
            【{attachment.name}】
          </a>
        )
      }
    }
    return <div>{elements}</div>
  }
}

export default AttachmentLinks
